exports = module.exports = require("../../../../../../lunch-team-client-checkout-msg/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".gdpr-terms-conditions a[target=_blank]{font-size:18px;color:#0e7a4b;text-decoration:none;border-bottom:1px;margin-top:30px}.gdpr-terms-conditions a[target=_blank]:hover{opacity:.7}.gdpr-privacy-policy a[target=_blank]{font-size:18px;color:#0e7a4b;text-decoration:none;border-bottom:1px;margin-top:30px}.gdpr-privacy-policy a[target=_blank]:hover{opacity:.7}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Users/fehin/LunchteamClaude/lunch-team-client-checkout-msg/node_modules/css-loader!/Users/fehin/LunchteamClaude/lunch-team-client-checkout-msg/node_modules/sass-loader/dist/cjs.js!./src/containers/GDPR/GDPR.scss
// module id = 786
// module chunks = 7